
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.4 32h15.2c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748C30 28.96 30 27.84 30 25.6V7l-7-7H8.4C6.16 0 5.04 0 4.184.436a4 4 0 00-1.748 1.748C2 3.04 2 4.16 2 6.4v19.2c0 2.24 0 3.36.436 4.216a4 4 0 001.748 1.748C5.04 32 6.16 32 8.4 32z","fill":"#F34"}}),_c('path',{attrs:{"opacity":".5","d":"M25 7h5l-7-7v5a2 2 0 002 2z","fill":"#fff"}}),_c('path',{attrs:{"d":"M6.832 21H8.37v-2.358h1.293c1.672 0 2.645-.998 2.645-2.45 0-1.446-.955-2.465-2.606-2.465h-2.87V21zm1.538-3.59v-2.426h1.037c.888 0 1.317.483 1.317 1.208 0 .72-.43 1.218-1.31 1.218H8.37zM15.885 21c2.216 0 3.558-1.37 3.558-3.643 0-2.266-1.342-3.63-3.537-3.63h-2.6V21h2.579zm-1.04-1.317v-4.638h.98c1.363 0 2.084.696 2.084 2.312 0 1.622-.72 2.326-2.088 2.326h-.976zM20.581 21h1.538v-3.004h2.958v-1.268H22.12v-1.733h3.278v-1.268h-4.816V21z","fill":"#fff"}})])
          )
        }
      }
    